import React from 'react';
import { Box, Chip, FormControl, MenuItem, Select, SelectChangeEvent, Typography } from '@mui/material';
import { FilterComponentProps } from './UserProfileFilters';
import { IGQLInvitationStatus } from '@/graphql-types';
import BaseFilterPill from './BaseFilterPill';
import FilterAltIcon from '@mui/icons-material/FilterAlt';

interface StatusFilterProps extends FilterComponentProps {
  value: IGQLInvitationStatus[] | undefined;
  onChange: (value: IGQLInvitationStatus[]) => void;
}

const STATUS_OPTIONS = [
  { value: IGQLInvitationStatus.Accepted, label: 'Accepted' },
  { value: IGQLInvitationStatus.Pending, label: 'Pending' },
  { value: IGQLInvitationStatus.Revoked, label: 'Revoked' },
  { value: IGQLInvitationStatus.Expired, label: 'Expired' },
];

const StatusFilter: React.FC<StatusFilterProps> = ({ value = [], onChange, onRemove }) => {
  const handleChange = (event: SelectChangeEvent<IGQLInvitationStatus[]>) => {
    const selectedValues = event.target.value as IGQLInvitationStatus[];
    onChange(selectedValues);
  };

  return (
    <BaseFilterPill
      icon={<FilterAltIcon fontSize="small" />}
      label="Status"
      onRemove={onRemove}
      background="#f0f7ff"
    >
      <FormControl size="small" sx={{ minWidth: 180 }}>
        <Select
          multiple
          value={value}
          onChange={handleChange}
          displayEmpty
          renderValue={(selected) => {
            if ((selected as IGQLInvitationStatus[]).length === 0) {
              return <Typography variant="body2" color="text.secondary">Any status</Typography>;
            }
            return (
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                {(selected as IGQLInvitationStatus[]).map((status) => (
                  <Chip 
                    key={status} 
                    label={STATUS_OPTIONS.find(opt => opt.value === status)?.label || status} 
                    size="small" 
                  />
                ))}
              </Box>
            );
          }}
          sx={{
            height: '100%',
            '& .MuiOutlinedInput-notchedOutline': { 
              border: 'none' 
            },
            '&:hover .MuiOutlinedInput-notchedOutline': { 
              border: 'none' 
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': { 
              border: 'none' 
            }
          }}
        >
          {STATUS_OPTIONS.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </BaseFilterPill>
  );
};

export default StatusFilter; 